import { Icon, symbolName } from './Icon'

type StarsIconProps = Readonly<{
  size?: number
  color?: string
}>

export function StarsIcon({ size = 24, color = '#777777' }: StarsIconProps) {
  return (
    <Icon
      name={symbolName('sparkles', 'auto_awesome')}
      size={size}
      color={color}
    />
  )
}
